





































































import { getFlagEmoji, getFlagEmojiByLanguage } from "@/lib/CountryCodeHelper";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IClearanceApproval, ClearanceApproval } from "@/models/clearance-approval.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import InvoiceFormPreview from "../invoice/InvoiceFormPreview.vue";
import { handleError } from "@/lib/utility/handleError";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import { InvoiceLine } from "@/models/invoice-line.entity";

@Component({
  components: {
    InvoiceFormPreview,
    LineItemsForm
  },
  filters: {
    getFlagEmojiByLanguage,
    getFlagEmoji
  }
})
export default class ClearanceApprovalDetailForm extends mixins(PartnerFallbackMixin, PermissionMixin, RulesMixin) {
  readonly RequestStatusEnum = RequestStatusEnum;

  @Prop()
  value!: IClearanceApproval;

  isUpdateChangesDialogActive = false;

  isSaveChangesLoading = false;

  valueCopy: IClearanceApproval | null = null;

  isValid = false;

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  beforeMount() {
    this.abortChanges();
  }

  @Watch("valueCopy.title", { deep: true })
  @Watch("valueCopy.lineItems", { deep: true })
  onTitleChange() {
    this.isUpdateChangesDialogActive = true;
  }

  abortChanges() {
    this.valueCopy = new ClearanceApproval(this.value);
    this.valueCopy.lineItems = this.value.lineItems.map(lineItem => new InvoiceLine(lineItem)) ?? [];

    this.$nextTick(() => {
      this.isUpdateChangesDialogActive = false;
    });
  }

  async saveChanges() {
    this.isSaveChangesLoading = true;
    await this.valueCopy
      ?.updatePartial({
        lineItems: this.valueCopy.lineItems.map(li => li.dto),
        title: this.valueCopy.title
      })
      .then(res => {
        this.isUpdateChangesDialogActive = false;
        this.value.map(res);
      })
      .catch(handleError);
    this.isSaveChangesLoading = false;
    this.isUpdateChangesDialogActive = false;
  }
}
